import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
// import { SnotifyService } from "../../../node_modules/ng-snotify";

import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators
} from "@angular/forms";
import { LogService } from '../services/log.service';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css']
})
export class HelpComponent implements OnInit {
  public myForm: FormGroup;
  public selectedFile: File = null;
  public subject: string;
  public message: string;
  public allImages = [];
  public errMessage = '';
  public image;
  public isFullyLoaded2;
  constructor(private fb: FormBuilder, private _userService: UserService, public log: LogService, public snackbar: MatSnackBar) {
    this.myForm = this.fb.group({
      images: ["", Validators.required],
      subject: ["", Validators.required],
      message: ["", Validators.required]
    });
  }

  ngOnInit() {
    this.log
      .addLog({
      action: "Access",
      component: "Help",
      details: `Accessed Help`,
    }).subscribe(data => { });
    this.isFullyLoaded2 = true;
  }
  uploadImages(files: File[]) {
    if (files.length > 0) {
      this.selectedFile = files[0];
      this.image = this.selectedFile.name;
      //console.log(event);
      this.log
        .addLog({
        action: "Upload",
        component: "Help",
        details: `Uploaded Image for Crash Report`,
      }).subscribe(data => { });
    }
  }
  sendCrashReport(details) {
    this.isFullyLoaded2 = false;
    let fd = new FormData();
    fd.append("textData", JSON.stringify(details));
    fd.append("imageArray", this.selectedFile, this.selectedFile.name);
    this._userService.sendCrashReport(fd).subscribe(data => {
      if (data.success) {
        this.log
          .addLog({
          action: "Send",
          component: "Help",
          details: `Sent Crash Report with the subject ${details.subject}`,
        }).subscribe(data => { });
        this.snackbar.open("Sent Successfully", "Dismiss", {
          duration: 5000
        })
        // this.Notify.simple("Sent successfully", {
        //   timeout: 2000,
        //   pauseOnHover: false,
        //   showProgressBar: false
        // });
        // this.response = "Data updated successfully";
        // this.respDisp = "alert-success";
      } else {
        this.snackbar.open("Unable to Send Report", "Dismiss", {
          duration: 5000
        })
        // this.Notify.simple("Failed! " + data.message, {
        //   timeout: 5000,
        //   pauseOnHover: false,
        //   showProgressBar: false
        // });
      }
      this.isFullyLoaded2 = true;
    })
  }


}
